import { safe, resolve } from '@fiverr-private/futile';

const LS_KEY_RECENT_INTERACTIONS = 'recentInteractions';

const getUserLS = (...args) => {
    const getFn = resolve('Fiverr.getUserLS');
    return safe(getFn, resolve('Fiverr'), ...args);
};

const setUserLS = (...args) => {
    const setFn = resolve('Fiverr.setUserLS');
    return safe(setFn, resolve('Fiverr'), ...args);
};

export const addRecentInteraction = (username) => {
    if (!username) {
        return;
    }

    let recentInteractions = getUserLS(LS_KEY_RECENT_INTERACTIONS) || [];

    recentInteractions = [...new Set([username, ...recentInteractions])].slice(0, 250); // max 250
    setUserLS(LS_KEY_RECENT_INTERACTIONS, recentInteractions);
};
